import { useEffect } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import NewsFeed from "./components/NewsFeed";
import DeepDive from "./components/DeepDive";
import StoryTimeline from "./components/StoryTimeline";
import Opinion from "./components/Opinion";
import Categories from "./components/Categories";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import { faqs, freshNews, brand } from "@/mocks/gua";

function injectJsonLd(id: string, data: object) {
  const prev = document.getElementById(id);
  if (prev) prev.remove();
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = id;
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

export default function Home() {
  useEffect(() => {
    injectJsonLd("schema-faq", {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    injectJsonLd("schema-collection", {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "最新速递 · 一线热讯",
      url: "https://khuyk.cn/#fresh",
      inLanguage: "zh-CN",
      isPartOf: { "@type": "WebSite", name: brand.name },
      hasPart: freshNews.map((n) => ({
        "@type": "Article",
        headline: n.title,
        about: n.cat,
      })),
    });
  }, []);

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Header />
      <main>
        <Hero />
        <NewsFeed />
        <DeepDive />
        <StoryTimeline />
        <Opinion />
        <Categories />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}